module.exports = "/_next/static/images/ourPartnersLogo6-8a81aded216562742beb11e6515e644d.webp";